import api from "../../../api/axios";

/** Feature-local corporate Client transport (C1 endpoints). Not personal CRM. */

export const fetchCompanyClients = (companyId, params) =>
  api
    .get(`/companies/${companyId}/clients/`, { params })
    .then((res) => res.data);

export const createCompanyClient = (companyId, body) =>
  api
    .post(`/companies/${companyId}/clients/`, body)
    .then((res) => res.data);

export const fetchCompanyClientsUnassigned = (companyId, params) =>
  api
    .get(`/companies/${companyId}/clients/unassigned/`, { params })
    .then((res) => res.data);

export const fetchCompanyClient = (companyId, clientId) =>
  api
    .get(`/companies/${companyId}/clients/${clientId}/`)
    .then((res) => res.data);

export const patchCompanyClient = (companyId, clientId, body) =>
  api
    .patch(`/companies/${companyId}/clients/${clientId}/`, body)
    .then((res) => res.data);

export const archiveCompanyClient = (companyId, clientId) =>
  api
    .post(`/companies/${companyId}/clients/${clientId}/archive/`)
    .then((res) => res.data);

export const assignCompanyClient = (companyId, clientId, userId) =>
  api
    .post(`/companies/${companyId}/clients/${clientId}/assign/`, {
      user_id: userId,
    })
    .then((res) => res.data);

export const fetchCompanyClientGrants = (companyId, clientId) =>
  api
    .get(`/companies/${companyId}/clients/${clientId}/grants/`)
    .then((res) => res.data);

export const upsertCompanyClientGrant = (companyId, clientId, body) =>
  api
    .put(`/companies/${companyId}/clients/${clientId}/grants/`, body)
    .then((res) => res.data);

export const revokeCompanyClientGrant = (companyId, clientId, grantId) =>
  api
    .post(
      `/companies/${companyId}/clients/${clientId}/grants/${grantId}/revoke/`,
    )
    .then((res) => res.data);

export const putCompanyClientPreferences = (companyId, clientId, body) =>
  api
    .put(`/companies/${companyId}/clients/${clientId}/preferences/`, body)
    .then((res) => res.data);

export const fetchCompanyClientContacts = (companyId, clientId) =>
  api
    .get(`/companies/${companyId}/clients/${clientId}/contacts/`)
    .then((res) => res.data);

export const createCompanyClientContact = (companyId, clientId, body) =>
  api
    .post(`/companies/${companyId}/clients/${clientId}/contacts/`, body)
    .then((res) => res.data);

export const updateCompanyClientContact = (
  companyId,
  clientId,
  contactId,
  body,
) =>
  api
    .patch(
      `/companies/${companyId}/clients/${clientId}/contacts/${contactId}/`,
      body,
    )
    .then((res) => res.data);

export const deleteCompanyClientContact = (companyId, clientId, contactId) =>
  api
    .delete(
      `/companies/${companyId}/clients/${clientId}/contacts/${contactId}/`,
    )
    .then(() => undefined);

export const fetchCompanyClientCommunications = (companyId, clientId) =>
  api
    .get(`/companies/${companyId}/clients/${clientId}/communications/`)
    .then((res) => res.data);

export const createCompanyClientCommunication = (companyId, clientId, body) =>
  api
    .post(`/companies/${companyId}/clients/${clientId}/communications/`, body)
    .then((res) => res.data);

/** Personal → company transfer preview (OWNER/ADMIN). Always apply_available:false. */
export const previewClientTransfer = (companyId, clientId) =>
  api
    .post(`/companies/${companyId}/clients/transfer-preview/`, {
      client_id: clientId,
    })
    .then((res) => res.data)
    .catch((error) => {
      const status = error?.response?.status;
      const data = error?.response?.data;
      if (
        status === 409 &&
        data &&
        typeof data === "object" &&
        data.code === "transfer_blocked_links"
      ) {
        return data;
      }
      throw error;
    });
